import { usageTier, USAGE_FILL, USAGE_TRACK } from '@/lib/usage';

// The 3-tier free-usage bar (blue → amber → red), shared by the Account plan
// card and the Dashboard usage section so the gauge is defined once.
// See REFERENCE/plans/PLAN_C8_AT_CAP_UI.md.
export function UsageBar({ count, limit }: { count: number; limit: number }) {
  const { state, percent } = usageTier(count, limit);
  return (
    <div className={`h-2 w-full overflow-hidden rounded-full ${USAGE_TRACK[state]}`}>
      <div
        className={`h-full rounded-full ${USAGE_FILL[state]} transition-all`}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
